import { HSComponent } from './component.js';
import styles from './checkbox-toggle.css';
import template from './checkbox-toggle.html';

export class HSCheckboxToggle extends HSComponent {
    onLoad() {
        this.loadTemplate(template);
        this.loadStyles(styles);

        const input = this.shadowRoot.querySelector('input');
        const label = this.shadowRoot.querySelector('.label');

        if (this.hasAttribute('checked')) {
            input.checked = true;
        }
        if (this.hasAttribute('name')) {
            input.name = this.getAttribute('name');
        }
        if (this.hasAttribute('value')) {
            input.value = this.getAttribute('value');
        }
        if (this.hasAttribute('label')) {
            label.textContent = this.getAttribute('label');
        }

        this.onEvent('change', (data, ev) => {
            this.emit({ type: 'change', checked: ev.target.checked, value: ev.target.value, source: this });
        }, input);
    }
}

customElements.define('hs-checkbox-toggle', HSCheckboxToggle);
